import { useEffect, useState } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import { breakpoints } from '@/config/layout'

export enum ScreenType {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}

/**
 * Returns the screen type based on the breakpoints.
 * @returns The screen type (mobile, tablet, desktop) or null during initialization
 */
export const useScreenType = (): ScreenType | null => {
  const [isInitialized, setIsInitialized] = useState(false)
  const isDesktopLayout = useMediaQuery(breakpoints.l)
  const isTabletLayout = useMediaQuery(breakpoints.fromS)

  useEffect(() => {
    // Mark as initialized after first render
    setIsInitialized(true)
  }, [])

  // Return null during initialization
  if (!isInitialized) {
    return null
  }

  if (isDesktopLayout) {
    return ScreenType.Desktop
  }
  if (isTabletLayout) {
    return ScreenType.Tablet
  }
  return ScreenType.Mobile
}
